// libs/ui/common/access-control-common/src/constants/sidebarItems.ts
import * as React from 'react';
import { DashboardOutlined, TeamOutlined, UserOutlined, SettingOutlined, UnlockOutlined, KeyOutlined, FileSearchOutlined, DatabaseOutlined, FlagOutlined, LinkOutlined, MailOutlined, IdcardOutlined, } from '@ant-design/icons';
export const sidebarItems = [
    {
        label: 'Dashboard',
        key: '/dashboard',
        icon: React.createElement(DashboardOutlined),
    },
    {
        label: 'Tenants',
        key: '/tenants',
        icon: React.createElement(DatabaseOutlined),
        children: [{ label: 'Create Tenant', key: '/tenants/create' }],
    },
    {
        label: 'Users',
        key: '/users',
        icon: React.createElement(UserOutlined),
        children: [
            { label: 'Create User', key: '/users/create' },
            // etc.
        ],
    },
    {
        label: 'Roles',
        key: '/roles',
        icon: React.createElement(TeamOutlined),
    },
    {
        label: 'Features',
        key: '/features',
        icon: React.createElement(SettingOutlined),
    },
    {
        label: 'Permissions',
        key: '/permissions',
        icon: React.createElement(UnlockOutlined),
    },
    {
        label: 'Feature Flags',
        key: '/feature-flags',
        icon: React.createElement(FlagOutlined),
    },
    {
        label: 'Consents',
        key: '/consents',
        icon: React.createElement(FileSearchOutlined),
    },
    {
        label: 'Sessions',
        key: '/sessions',
        icon: React.createElement(KeyOutlined),
    },
    {
        label: 'Login Attempts',
        key: '/login-attempts',
        icon: React.createElement(FileSearchOutlined),
    },
    {
        label: 'Invitations',
        key: '/invitations',
        icon: React.createElement(MailOutlined),
    },
    {
        label: 'Permission Assignments',
        key: '/permission-assignments',
        icon: React.createElement(LinkOutlined),
    },
    {
        label: 'User Profiles',
        key: '/user-profiles',
        icon: React.createElement(IdcardOutlined),
    },
    {
        label: 'Settings',
        key: '/settings',
        icon: React.createElement(SettingOutlined),
    },
];
//# sourceMappingURL=sidebarItems.js.map